module.exports = __webpack_public_path__ + "img/filter.1bb86f57.svg";